<template>
  <div class="hoxton-alter-wall">
    <Loader :loading="showLoader" />
    <v-toolbar color="#222222" flat dense class="mb-4" style="cursor: pointer">
      <v-icon color="#337b52" class="ml-2" size="40" @click="goBack">mdi-arrow-left-bold-circle</v-icon>
      <v-toolbar-title style="font-family: 'Material Design Icons'; font-size: 25px !important">
        The Hoxton – Alter Wall
      </v-toolbar-title>
    </v-toolbar>

    <div class="flex-gallery">
      <div v-for="(image, index) in hotelImages" :key="index" class="flex-item">
        <img :src="image.src" :alt="image.name" class="gallery-img" />
        <div class="img-caption">{{ image.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import Loader from '@/components/Loader.vue';

export default {
  name: "HoxtonAlterWall",
  components: {
    Loader,
  },
  setup() {
    const router = useRouter();
    const showLoader = ref(true);

    const hotelImages = ref([
      { name: "Hoxton in Berlin Wintergarten", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Hoxton in Berlin Wintergarten.jpg") },
      { name: "Hoxton in Berlin", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Hoxton in Berlin.jpg") },
      { name: "Hoxton in Brüssel Lobby", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Hoxton in Brüssel Lobby.jpg") },
      { name: "Hoxton in Chicago Lobby", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Hoxton in Chicago Lobby.jpg") },
      { name: "Hoxton in Chicago", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Hoxton in Chicago.jpg") },
      { name: "Hoxton Zimmer", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Hoxton Zimmer.jpg") },
      { name: "Hoxton in Paris Lobby", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Hoxton in Paris Lobby.jpg") },
      { name: "Hoxton in Paris", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Hoxton in Paris.jpg") },
      { name: "Hoxton in London", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Hoxton in London.jpg") },
      { name: "Rooftop Restaurant Seabird in London", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Rooftop Restaurant Seabird in London.jpg") },
      { name: "Hoxton in Vienna", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Hoxton in Vienna.jpg") },
      { name: "Rooftop Terrace in London", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Rooftop Terrace in London.jpg") },
      { name: "Hoxton in Brüssel", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Hoxton in Brüssel.jpg") },
      { name: "Hoxton Waschtisch", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Hoxton Waschtisch.jpg") },
      { name: "Hoxton in Berlin Zimmer", src: require("@/assets/Branding/Artinvest/HoxtonAlterWallPictures/Hoxton in Berlin Zimmer.jpg") },

    ]);

    const goBack = () => {
      router.go(-1);
    };

    onMounted(() => {
      setTimeout(() => {
        showLoader.value = false;
      }, 1000);
    });

    return {
      showLoader,
      goBack,
      hotelImages,
    };
  },
};
</script>

<style scoped>
.flex-gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 32px;
  padding: 32px 16px 80px;
  max-width: 1400px;
  margin: 0 auto;
}

.flex-item {
  flex: 1 1 calc(50% - 32px);
  /* 2 per row on small to medium */
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (min-width: 1200px) {
  .flex-item {
    flex: 1 1 calc(33.33% - 32px);
    /* 3 per row on large */
  }
}

.gallery-img {
  width: 100%;
  /* border-radius: 12px; */
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.1);
  object-fit: cover;
}

.img-caption {
  margin-top: 10px;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  color: #444;
  padding: 0 8px;
}
</style>
